module.exports = __webpack_public_path__ + "static/img/animales_25.d2537d26.jpg";